import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActivityNameIcon } from './activity_icon.component';
import { ButtonView } from './button_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const ProtocolSchedulePreview = ({ productMessages, messages, sortIndex }) => {
    if (!messages) {
        return null;
    }
    return Object.keys(messages)
        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
        .map((key) => {
        var _a, _b;
        return (_jsxs("div", { "data-study-product-version": 'r400', style: {
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#f5f4f9',
                padding: '3rem 1rem 1rem 1rem',
                rowGap: '0.5rem',
                height: '100%',
                borderRadius: '1rem',
                marginBottom: '1rem',
            }, children: [_jsx("div", { style: { fontSize: '15px', fontWeight: '600', lineHeight: '24px', color: '#111827' }, children: messages[key] }), _jsxs("div", { style: {
                        border: '1px solid rgb(209, 213, 219)',
                        padding: '2em',
                        color: 'rgb(17, 24, 39)',
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        fontSize: '16px',
                        fontWeight: '600',
                        lineHeight: '24px',
                    }, children: [_jsxs("div", { style: {
                                position: 'relative',
                                paddingInlineStart: 35,
                                marginBottom: 15,
                                wordBreak: 'normal',
                                overflowWrap: 'anywhere',
                            }, children: [_jsx("div", { style: { width: 24, height: 24, position: 'absolute', insetInlineStart: 0, top: 0 }, children: _jsx(ActivityNameIcon, {}) }), (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.activity_placeholder) !== null && _a !== void 0 ? _a : 'Activity'] }), _jsx(ButtonView, { label: (_b = productMessages === null || productMessages === void 0 ? void 0 : productMessages.button) !== null && _b !== void 0 ? _b : 'Start', customStyles: { height: 40 } })] })] }, `protocol-schedule-root-${key}`));
    });
};
//# sourceMappingURL=protocol_schedule.previews.component.js.map